module.exports = __webpack_public_path__ + "img/product-cc.6b61c58b.svg";